// Import modules
import activateToggle from './modules/menu-toggle';
import activatePrintButton from './modules/print-button';
// import initializeGlide from './modules/glide';
// import fixedNav from './modules/fixedNav';

window.addEventListener('load', () => {
  // Initialize modules
  activateToggle();
  activatePrintButton();

  // Glide carousel. Remove if not needed in the project.
  // initializeGlide();
  // Shrinking fixed navbar. Remove if not needed in the project.
  // fixedNav();
});
